import { ArticleDto } from "@lib/ShiOneClient";

export type NavigationDirection = "Up" | "Down";

export const IsNewsLink = (
  article?: ArticleDto | null,
): article is ArticleDto & { sourceUrl: string } => {
  return (
    !!article &&
    (article.category === "Blog" || article.category === "News") &&
    !!article.sourceUrl
  );
};

